module.exports = __webpack_public_path__ + "img/gratiaimage4.d2d5ffd5.jpg";